// Different betwwen U & App
export const PAYMENT_STATE = {
    CARD: 'CARD',
    ERROR: 'ERROR',
    LOADER: 'LOADER',
}

// Used only in this repo yet
export const MIXPANEL_PROJECT_TOKEN = 'cdb9c4d5b4eec7b52083a794f9744d0d'
export const TinyMCE_API_Key = 'j5s68ydkayad5vqvt7uhmxss5u1q5izurhn97s9cvyj3xzyd'

// Used only in this repo
export const MIXPANEL_EVENTS = {
    SIGN_IN: {
        ONBOARDING: 'Sign in to Onboarding',
        HOME: 'Sign in to Home page',
        ERROR: 'Sign in getDashboard error',
    },
    ASSESSMENT: {
        VISITED: 'Visit to Assessment',
        SEND: 'Assessment finished',
    },
    GOALS: {
        SEND: 'Assesment update',
    },
    HOME: 'Home',
    RECOMMENDED_RESOURCE: 'ResourceCard onClick',
    PURCHASE: {
        CONFIRMATION: 'Order confirmation',
    },
    DIRECTORY: {
        VISITED: 'Discover page',
    },
    RESOURCE: {
        VISITED: 'Resource page',
    },
    ORDERS: {
        VISITED: 'Orders page',
    },
    RATE: {
        SEND: 'Rate',
    },
    TICKET: {
        SEND: 'Send ticket',
    },
    NEWSLETTER: {
        VISITED: 'Landing page',
    },
    PROFILE: {
        VISITED: 'Profile',
    },
}
